export default __webpack_public_path__ + "static/media/73g.7279c420.svg";